import { RouterProvider } from '@tanstack/react-router'
import { router } from './routes'
import { AuthProvider } from './context/AuthProvider'
import { CustomisationProvider } from './context/CustomisationProvider'

import 'antd/dist/reset.css'
import './App.css'

const App = () => {
  return (
    <RouterProvider
      router={router}
      context={{
        CustomisationProvider,
        AuthProvider,
      }}
    />
  )
}

export default App
